// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2cWKT","overflowing":"ReadFullNote_overflowing__i26gT"};